// JavaScript source code

import Vue from 'vue';
var globalStore = new Vue({
    data: {
       
            globalBenefit: ''
       
    },
    methods: {
        updateItem: function (newValue) {
            this.globalBenefit = newValue;
        }
    }
})


export default globalStore;



// WEBPACK FOOTER //
// ./src/models/variables.js